import styled from '@emotion/styled'

export const Scroll = styled.div`
  min-height: 120px;
  max-height: 480px;
  padding-right: 20px;
  overflow-y: auto;
`
